import { EMainProductCodeType } from '@aqx-core/common/api/config';
import { EOrderType, IOrder } from '@aqx-core/common/api/order';
import { calculateProfitOrLoss } from '@aqx-core/common/calculation/profit';
import { companyViewController } from '@aqx-core/common/services/company/controller';
import { ISymbolTopicLivePrices } from '@aqx-core/common/socket/subscriptions/types';
import { safetyCheckForNumberValues } from '@aqx-core/common/utils/number';

export const calculateLiveProfitForOrder = (
  order: IOrder,
  livePrices: Pick<ISymbolTopicLivePrices, 'liveBuy' | 'liveSell'>
): number => {
  const { orderType, lotSize, openPrice, profit, contractSize, exchangeRate } = order;
  const { liveBuy, liveSell } = livePrices;

  const isCentroid = companyViewController.getCompanyIntegration() === EMainProductCodeType.CENTROID;

  let currentPrice: number;
  let isSellOrder: boolean;
  let formattedOrderType: EOrderType;

  // Centroid use lot size to determine order type , positive volume is buy, negative volume is sell
  if (isCentroid) {
    formattedOrderType = order.lotSize > 0 ? EOrderType.BUY : EOrderType.SELL;
  } else {
    formattedOrderType = orderType;
  }

  switch (formattedOrderType) {
    case EOrderType.BUY:
    case EOrderType.BUY_STOP:
    case EOrderType.BUY_LIMIT:
      currentPrice = liveSell;
      isSellOrder = false;
      break;
    case EOrderType.SELL:
    case EOrderType.SELL_STOP:
    case EOrderType.SELL_LIMIT:
      currentPrice = liveBuy;
      isSellOrder = true;
      break;
    default:
      return safetyCheckForNumberValues(profit);
  }

  if (currentPrice <= 0) {
    return safetyCheckForNumberValues(profit);
  }

  return calculateProfitOrLoss({
    lotSize: safetyCheckForNumberValues(lotSize),
    openPrice: safetyCheckForNumberValues(openPrice),
    contractSize: safetyCheckForNumberValues(contractSize),
    exchangeRate: safetyCheckForNumberValues(exchangeRate),
    currentPrice: safetyCheckForNumberValues(currentPrice),
    profit: safetyCheckForNumberValues(profit),
    isSellOrder
  }).toNumber();
};

export const updateOrdersWithLiveProfits = (
  orders: IOrder[],
  symbolId: string,
  livePrices: ISymbolTopicLivePrices
): IOrder[] => {
  return orders.map((order) => {
    if (order.symbol !== symbolId) {
      return order;
    }

    const newProfit = calculateLiveProfitForOrder(order, livePrices);

    return {
      ...order,
      profit: newProfit
    };
  });
};
